import React, { useEffect, useState } from "react";
import "common/css/master.css";
import { toast, ToastContainer } from "react-toastify";
import { dtToDMY, dmyToDate } from "common/functions/dateUtil";
import Header from "common/js/header/header";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';

import AbsentTeachersTbl from "./absentTeaherTbl";
import { getAbsentTeachersSvc } from "./absentTeachersSvc";

const AbsentTeacherCtrl = () => {

    const [fromDt, setFromDt] = useState("");
    const [toDt, setToDt] = useState("");
    const [lstTchAbsent, setLstTchAbsent] = useState([]);
    const [loader, setLoader] = useState("none");
    const [opacity, setOpacity] = useState(1);
    const [tchId, setTchId] = useState(0);
    const [absentDt, setAbsentDt] = useState("");

    useEffect(() => {
        const currentDate = new Date();
        setToDt(dtToDMY(currentDate));
        const startDate = new Date(currentDate);
        // by default first date of the month
        startDate.setDate(1);
        setFromDt(dtToDMY(startDate));
        if (fromDt && toDt) {
            // getAbsentTeachers(fromDt, toDt);
        }
    }, []);
    const getAbsentTeachers = (stDt, endDt) => {
        setLoader("block");
        setOpacity(0.5);
        // Call the service to get the absent teachers
        getAbsentTeachersSvc(stDt, endDt, handleAbsentTeachersResponse);
    };

    const handleAbsentTeachersResponse = (data) => {
        setLoader("none");
        setOpacity(1);
        if (data.status === 'Success') {
            setLstTchAbsent(data.lstTchAbsent || []);
        } else {
            handleServiceError(data.message || "Failed to fetch absent teachers");
        }
    };

    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg || "An error occurred");
        }
    };


    return (
        <div >
            <Header />
            <ToastContainer autoClose={3000} hideProgressBar />
            <div className="col-lg-6 col-md-6 col-sm-8 col-xs-12 col-centered padding-remove" style={{ marginTop: "20px" }}>
                <div className="col-sm-12 col-centered padding-remove">
                    <div className="col-sm-4 padding-remove">
                        <label className='col-sm-3 padding-remove'>From:</label>
                        <div className="col-sm-8 padding-remove" style={{ position: "relative" }}>
                            <DatePicker
                                id="selDtFrom"
                                className="form-control pr-4"
                                placeholderText="From Date"
                                selected={dmyToDate(fromDt)}
                                onChange={(dt) => setFromDt(dtToDMY(dt))}
                                dateFormat="dd-MM-yyyy"
                                dropdownMode="select"
                                autoComplete="off"
                                showMonthDropdown
                                showYearDropdown
                                adjustDateOnChange
                            />
                            <span
                                id="calendar1"
                                title="calendar"
                                className="glyphicon glyphicon-calendar"
                                style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    color: "#666",
                                }}
                                onClick={() => document.getElementById("selDtFrom").focus()}
                            ></span>
                        </div>
                    </div>
                    <div className="col-sm-4 padding-remove">
                        <label className='col-sm-3 padding-remove'>To:</label>
                        <div className="col-sm-8 padding-remove" style={{ position: "relative" }}>
                            <DatePicker
                                id="selDtTo"
                                className="form-control pr-4"
                                placeholderText="To Date"
                                selected={dmyToDate(toDt)}
                                onChange={(dt) => setToDt(dtToDMY(dt))}
                                dateFormat="dd-MM-yyyy"
                                dropdownMode="select"
                                autoComplete="off"
                                showMonthDropdown
                                showYearDropdown
                                adjustDateOnChange
                            />
                            <span
                                id="calendar2"
                                title="calendar"
                                className="glyphicon glyphicon-calendar"
                                style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    color: "#666",
                                }}
                                onClick={() => document.getElementById("selDtTo").focus()}
                            ></span>
                        </div>
                    </div>
                    <div className="col-sm-4  padding-remove">
                        <div style={{ width: "100px" }}>
                            <button
                                type="button"
                                style={{ width: "100%" }}
                                className="btn btn-primary pull-right"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    getAbsentTeachers(fromDt, toDt);
                                }}>
                                View
                            </button>
                        </div>
                    </div>
                </div>
                <div className="col-sm-12 col-centered padding-remove" style={{ marginTop: "50px" }}>
                    <AbsentTeachersTbl
                        lstTchAbsent={lstTchAbsent}
                        tchId={tchId}
                        setTchId={setTchId}
                        absentDt={absentDt}
                        setAbsentDt={setAbsentDt}
                    />
                </div>
            </div>
        </div >
    );

}
export default AbsentTeacherCtrl;